module.exports = __webpack_public_path__ + "static/media/cabinet-filing.39a89651.svg";